import UploadPBXCsvModal from './UploadPBXCsvModal';
import { PbxCsvUploadTypes } from 'models/enums';

const { PBX_LINE_DETAILS } = PbxCsvUploadTypes;

type UploadPBXLineDetailsModalProps = {
  isOpen: boolean;
  closeModal: () => void;
};

function UploadPBXLineDetailsModal({ isOpen, closeModal }: UploadPBXLineDetailsModalProps) {
  return (
    <UploadPBXCsvModal
      isOpen={isOpen}
      closeModal={closeModal}
      uploadType={PBX_LINE_DETAILS}
      header="Upload PBX Line Details"
      title="Upload PBX Line Details"
      description="Update name, caller ID, and forward-always settings for existing lines via a .csv file"
      dataTestId="upload-pbx-line-details-button"
    />
  );
}

export default UploadPBXLineDetailsModal;
